'use client';
import Image from 'next/image';
import Link from 'next/link';

const events = [
  {
    name: "expotobi",
    src: "/images/expotobi.webp",
    link: "https://expotobi.in/",
  },
  {
    name: "cioreview",
    src: "/images/cioreview.webp",
    link: "https://www.cioreview.com/",
  },
  {
    name: "tekafrika",
    src: "/images/tekafrika-logo.webp",
    link: "https://tekafrika.tv/",
  },
  {
    name: "smartmoneymatch",
    src: "/images/smartmoneymatch.webp",
    link: "https://www.smartmoneymatch.com/help/media-partnerships",
  },
  {
    name: "transportstake",
    src: "/images/transportstake.webp",
    link: "https://www.transportstake.com/",
  },
  {
    name: "publicitymarketplace",
    src: "/images/publicitymarketplace.webp",
    link: "https://www.publicitymarketplace.com/en/media-library",
  },
  {
    name: "functionalsourcing",
    src: "/images/functionalsourcing.webp",
    link: "https://www.functionalsourcing.com/en/media-library",
  },
  {
    name: "educationstake",
    src: "/images/educationstake.webp",
    link: "https://www.educationstake.com/en/media-library",
  },
  {
    name: "matchsdg",
    src: "/images/match-sdg.webp",
    link: "https://www.matchsdg.com/en/media-library",
  },
  {
    name: "huidu",
    src: "/images/huidu-logo.webp",
    link: "https://www.huidu.cn/en",
  },
  {
    name: "cxquest",
    src: "/images/cxquest.webp",
    link: "https://cxquest.com/",
  },
  {
    name: "cionews",
    src: "/images/themainstream.webp",
    link: "https://cionews.co.in/",
  },
  {
    name: "bfmtimes",
    src: "/images/bftimes.webp",
    link: "https://bfmtimes.com/",
  },
  {
    name: "securityafricamagazine",
    src: "/images/securityafricamagazine-logo.webp",
    link: "https://securityafricamagazine.com/",
  },
  {
    name: "westasiawatch",
    src: "/images/wetasiawatch-logo.webp",
    link: "https://westasiawatch.com/",
  },
  {
    name: "nendigital",
    src: "/images/nedigiital-logo.webp",
    link: "http://www.nendigital.com/",
  },
  {
    name: "industryevents",
    src: "/images/idustryevents-logo.webp",
    link: "https://www.industryevents.com/",
  },
  {
    name: "thecatalyst",
    src: "/images/thecatalyst-logo.webp",
    link: "https://thecatalystonline.com/",
  },
  {
    name: "enterpriseviewpoint",
    src: "/images/eterprise-logo.webp",
    link: "https://enterpriseviewpoint.com/",
  },
  {
    name: "grcoutlook",
    src: "/images/grc-outlook-logo.webp",
    link: "https://grcoutlook.com/",
  },
  {
    name: "impactnews",
    src: "/images/impactnews-logo.webp",
    link: "https://impactnews-wire.com/",
  },
  {
    name: "brandpr",
    src: "/images/brandprlogo.webp",
    link: "https://brandpr.io/",
  },
  {
    name: "gazetinternational",
    src: "/images/gazetinternational-logo.webp",
    link: "https://gazetinternational.com/",
  },
  {
    name: "cryptonite",
    src: "/images/cryptonite-logo.webp",
    link: "https://www.cryptonite.ae/",
  },
  {
    name: "menews247",
    src: "/images/menews-logo.webp",
    link: "https://menews247.com/",
  },
  {
    name: "securitymiddleeastmag",
    src: "/images/securitymiddleeastmag-logo.webp",
    link: "https://www.securitymiddleeastmag.com/",
  },
  {
    name: "btcwire",
    src: "/images/btcwire-logo.webp",
    link: "https://btcwire.io/",
  },
  {
    name: "timesofuae",
    src: "/images/timesofuaelogo.webp",
    link: "https://thetimesofuae.com/",
  },
  {
    name: "coinraftar",
    src: "/images/coinraftar-logo.webp",
    link: "https://coinraftar.com/",
  },
  {
    name: "etherpr",
    src: "/images/etherpr-logo.webp",
    link: "https://etherpr.com/",
  },
  {
    name: "edarabia",
    src: "/images/edarbia-logo.webp",
    link: "https://www.edarabia.com/",
  },
  {
    name: "zexprwire",
    src: "/images/zexprwire-logo.webp",
    link: "https://zexprwire.com/",
  },
  {
    name: "blockweeks",
    src: "/images/blockweeks.webp",
    link: "https://blockweeks.com/",
  },
  {
    name: "coinrab",
    src: "/images/coinrab.webp",
    link: "https://coinrab.com/",
  },
  {
    name: "huidu-technology-logo",
    src: "/images/huido-io.webp",
    link: "https://www.huidu.cn/",
  },
  {
    name: "exchange1-logo",
    src: "/images/exchange1-logo.webp",
    link: "https://www.exchange1.com/",
  },
];


const MediaPartnersSection = () => {
  return (
    <section data-component-id="src/app/MediaPartnersSection.tsx:191:4" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="191" data-component-end-line="227" data-component-file="MediaPartnersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22w-full%20px-4%20py-12%20flex%20flex-col%20items-center%20justify-center%22%7D" className="w-full px-4 py-12 flex flex-col items-center justify-center">
      <div data-component-id="src/app/MediaPartnersSection.tsx:192:6" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="192" data-component-end-line="226" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1570px%5D%20flex%20flex-col%20items-center%22%7D" className="w-full max-w-[1570px] flex flex-col items-center">
        {/* Title */}
        <h2 data-component-id="src/app/MediaPartnersSection.tsx:194:8" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="194" data-component-end-line="196" data-component-file="MediaPartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22mb-10%20text-2xl%20sm%3Atext-3xl%20md%3Atext-3xl%20text-center%20lg%3Atext-%5B48px%5D%20font-bold%20leading-tight%20lg%3Aleading-%5B56px%5D%20text-%5B%230F0F0F%5D%20mb-8%22%2C%22textContent%22%3A%22Media%20Partners%22%7D" className="mb-10 text-2xl sm:text-3xl md:text-3xl text-center lg:text-[48px] font-bold leading-tight lg:leading-[56px] text-[#0F0F0F] mb-8">
           Media Partners
        </h2>

        {/* Events Grid */}
        <div data-component-id="src/app/MediaPartnersSection.tsx:199:8" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="199" data-component-end-line="225" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1270px%5D%22%7D" className="w-full max-w-[1270px]">
          <div data-component-id="src/app/MediaPartnersSection.tsx:200:10" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="200" data-component-end-line="224" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-3%20md%3Agrid-cols-6%20gap-x-4%20gap-y-4%20justify-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-x-4 gap-y-4 justify-items-center">
            {events.map((event, index) => (
              <a data-component-id="src/app/MediaPartnersSection.tsx:202:14" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="202" data-component-end-line="222" data-component-file="MediaPartnersSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%7D"
                key={index}
                href={event.link}
                target="_blank"
                rel={
                  event.link === "https://www.cryptonewsz.com/"
                    ? "noopener noreferrer"
                    : "noopener noreferrer nofollow"
                }
              >
                <div data-component-id="src/app/MediaPartnersSection.tsx:212:16" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="212" data-component-end-line="221" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B140px%5D%20h-%5B90px%5D%20sm%3Aw-%5B160px%5D%20sm%3Ah-%5B100px%5D%20md%3Aw-%5B120px%5D%20md%3Ah-%5B110px%5D%20lg%3Aw-%5B200px%5D%20lg%3Ah-%5B80px%5D%20rounded-%5B16px%5D%20flex%20items-center%20justify-center%20transition-transform%20duration-200%20hover%3Ascale-105%20border-2%20border-%5B%2302CF65%5D%20rounded-%5B10px%5D%20p-4%22%7D" className="w-[140px] h-[90px] sm:w-[160px] sm:h-[100px] md:w-[120px] md:h-[110px] lg:w-[200px] lg:h-[80px] rounded-[16px] flex items-center justify-center transition-transform duration-200 hover:scale-105 border-2 border-[#02CF65] rounded-[10px] p-4">
                  <Image data-component-id="src/app/MediaPartnersSection.tsx:213:18" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="213" data-component-end-line="220" data-component-file="MediaPartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20w-full%20h-%5B70px%5D%22%7D"
                    src={event.src}
                    alt={event.name}
                    width={200}
                    height={120}
                    className="object-contain w-full h-[70px]"
                    unoptimized
                  />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaPartnersSection;
